<template>
  <form-group
      :name="name"
      :label="label"
      :required="required"
      :inline="inline"
      :errors="errors"
  >
    <textarea
        class="form-control"
        :class="{ 'border-0 input-message': isMessage }"
        :id="name"
        :placeholder="placeholder"
        :value="value"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
        :rows="rows || 3"
    />
    <slot/>
  </form-group>
</template>

<script>
import FormGroup from './FormGroup';

export default {
  name: "TextArea",
  components: {
    FormGroup
  },
  props: {
    name: String,
    value: [String, Number],
    label: String,
    placeholder: String,
    rows: Number,
    required: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    errors: Array,
    inline: {
      type: Boolean,
      default: false
    },
    isMessage: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-message {
  background-color: #f8f9fa;
}
</style>
